var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"version":"1.1","id":"Dot_single","x":"0px","y":"0px","viewBox":"0 0 20 20","enableBackground":"new 0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M7.8,10c0,1.215,0.986,2.2,2.201,2.2S12.2,11.214,12.2,10c0-1.215-0.984-2.199-2.199-2.199S7.8,8.785,7.8,10z"}}],"content":"\r\n"})(props);
};
